import React from 'react';
import { makeStyles } from '@material-ui/core';
import Page from 'src/components/Page';
import Hero from './Hero';
import Features from './Features';
import Testimonials from './Testimonials';
import CTA from './CTA';
import FAQS from './FAQS';
import useAuth from 'src/hooks/useAuth';

const useStyles = makeStyles(() => ({
  root: {}
}));

const HomeView = () => {
  const classes = useStyles();
  const { user } = useAuth();
  return (
    <Page
      className={classes.root}
      title="Home"
    >
      {
        user == null ? <Hero EndpointRoot={true} /> : <Hero EndpointRoot={user.endpointRoot} />
      }
    </Page>
  );
};

export default HomeView;
